import { type FC } from 'react'
import { type TableContentStoryblok, type TableStoryblok } from '~/types/generated'
import styles from './Table.module.scss'

type TableHead = TableContentStoryblok['thead'][0]
type TableBody = TableContentStoryblok['tbody'][0]
type TableBodyContent = TableBody['body'][0]

export const Table: FC<TableStoryblok> = ({ table }) => {
  const thead = table?.thead
  const tbody = table?.tbody

  return (
    <div className={styles.container}>
      <table>
        <thead>
          <tr>
            {thead?.map((th: TableHead) => (
              // eslint-disable-next-line no-underscore-dangle
              <th key={th._uid}>{th.value}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tbody?.map((tr: TableBody) => (
            // eslint-disable-next-line no-underscore-dangle
            <tr key={tr._uid}>
              {tr.body?.map((td: TableBodyContent) => (
                // eslint-disable-next-line no-underscore-dangle
                <td key={td._uid}>{td.value}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
